const skills = [
  {
    id: 'python-ai-runtimes',
    name: 'Python / AI Runtimes',
    proficiency: 90,
    category: 'Programming',
    yearsOfExperience: 2,
    orderIndex: 1,
  },
  {
    id: 'java-oop',
    name: 'Java / OOP',
    proficiency: 85,
    category: 'Programming',
    yearsOfExperience: 1.5,
    orderIndex: 2,
  },
  {
    id: 'mern-stack',
    name: 'MERN Stack',
    proficiency: 75,
    category: 'Frontend',
    yearsOfExperience: 1,
    orderIndex: 3,
  },
  {
    id: 'machine-learning',
    name: 'Machine Learning',
    proficiency: 85,
    category: 'Tools',
    yearsOfExperience: 2,
    orderIndex: 4,
  },
  {
    id: 'pandas-numpy',
    name: 'Pandas / NumPy',
    proficiency: 88,
    category: 'Tools',
    yearsOfExperience: 1.5,
    orderIndex: 5,
  },
  {
    id: 'stock-analysis',
    name: 'Stock Analysis',
    proficiency: 92,
    category: 'Other',
    yearsOfExperience: 1,
    orderIndex: 6,
  },
  {
    id: 'react-js',
    name: 'React.js',
    proficiency: 80,
    category: 'Frontend',
    yearsOfExperience: 1,
    orderIndex: 7,
  },
  {
    id: 'node-js',
    name: 'Node.js',
    proficiency: 85,
    category: 'Backend',
    yearsOfExperience: 1,
    orderIndex: 8,
  },
];

export default skills;
